import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDeviceKey } from "../useDeviceKey";
import { deleteRecordingRows } from "@/utils/deleteCurrentRecording";
import useAuth from "../useAuth";
import useToast from "../../contexts/Toast/useToast";
import { useTranslation } from "react-i18next";
import { useErrorHandler } from "@/hooks/useErrorHandler";

export const useDeleteRecording = () => {
  const { t } = useTranslation();

  const deviceKey = useDeviceKey();

  const { token } = useAuth();

  const { showSuccessToast } = useToast();

  const { errorHandler } = useErrorHandler();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ recordingIds }: { recordingIds: string[] }) => await deleteRecordingRows(deviceKey, recordingIds, token),
    mutationKey: ["deleteRecording"],
    onError: (error: Error) => {
      errorHandler(error, {
        eventName: "DELETE-RECORDING-IN-BULK",
        showToast: true,
        properties: {
          endpoint: "/recording",
          reason: `Error deleting recording - ${error?.message}`,
        },
      });
    },
    onSuccess: (_, { recordingIds }) => {
      showSuccessToast(t("deleteRecording.toast.success", { items: recordingIds.length }));
      queryClient.invalidateQueries({ queryKey: ["recordingSubjects"] });
    },
  });
};
